import styled from 'styled-components';
import { mediaQuery } from '../../common/styles/styleUtil';

export const LatestProjectReviewFooterContainer = styled.div`
  background: #f7f8f9;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px -2px 4px rgba(105, 118, 132, 0.3);
  &[aria-describedby='sticky'] {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 1;
  }
  @media (${mediaQuery.mobile}) {
    display: flex;
  }
`;

export const LatestProjectReviewFooter = styled.div`
  padding: 24px;
  display: grid;
  grid-template-columns: 1fr 154px;
  gap: 32px;
  width: 100%;
  max-width: 1164px;
  @media (${mediaQuery.mobile}) {
    padding: 16px;
    gap: 24px;
  }
  @media (${mediaQuery.tablet}) {
    padding: 24px 16px;
    gap: 24px;
  }
`;

export const LatestProjectReviewDetail = styled.div`
  display: grid;
  gap: 4px;
`;

export const LatestProjectReviewButton = styled.a`
  color: #fff;
  background: #0081c6;
  border-radius: 3px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  height: 40px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 154px;

  @media (${mediaQuery.mobile}) {
    max-width: 137px;
  }
  &:hover {
    color: #fff;
  }
`;

export const LatestProjectReviewTitle = styled.p`
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 14px;
  color: #697684;
  margin: 0;
  @media (${mediaQuery.mobile}) {
    display: none;
  }
  @media (${mediaQuery.tablet}) {
    display: none;
  }
`;

export const LatestProjectReviewDescription = styled.p`
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  color: #333f48;
  margin: 0;
  @media (${mediaQuery.mobile}) {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
